import { useQuery, UseQueryResult } from 'react-query';
import { APIError } from '~/src/utils/error';
import { fieldMappingService } from '../services';
import type { FieldMappingOptions } from '../types';
import { keys } from '../keys';

interface UseFieldMappingSourceOptionsProps {
  projectId: number;
  orgFprint: string;
  enabled?: boolean;
}

interface UseFieldMappingSourceOptionsResult {
  options: FieldMappingOptions;
  loading: boolean;
  error: string | null;
}

export const EMPTY_OPTIONS: FieldMappingOptions = {
  matter_fields: [],
  contact_fields: {},
};

export const useFieldMappingSourceOptions = ({
  projectId,
  orgFprint,
  enabled = true,
}: UseFieldMappingSourceOptionsProps): UseFieldMappingSourceOptionsResult => {
  const query: UseQueryResult<FieldMappingOptions, APIError> = useQuery(
    keys.sourceFields(projectId),
    () =>
      fieldMappingService.getSourceFieldDropdownOptions(orgFprint, projectId),
    {
      enabled: enabled && !!projectId && !!orgFprint,
      staleTime: 0, // Always refetch on invalidation
    },
  );

  return {
    options: query.data || EMPTY_OPTIONS,
    loading: query.isLoading,
    error: query.error?.message || null,
  };
};
